
import { defineComponent, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import useFootPrint from "@/hooks/useFootPrint";
import api from "@/api/axios";

import SlotFooter from "@/components/common/SlotFooter.vue";
export default defineComponent({
  name: "bnccdetail",
  components: {
    SlotFooter,
  },
  setup() {
    onMounted(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
    const route = useRoute();
    const id = ref(route.params.id);
    const classId = ref(route.params.classId);
    const bncc = ref({});
    const isFav = ref(false);
    //   axios.get("/M/Product").then(res=>{
    //     productsVO.value = res.data.obj;
    //   })
    const comp = ref({});
    const { setFootItem } = useFootPrint();
    api
      .get("/M/Product/BNCCDetail/" + id.value)
      .then((res): void => {
        const data = res.data.obj;
        bncc.value = data.bncc;
        isFav.value = data.isFav;
        setFootItem({
          type: "bncc",
          img: data.bncc.switchBnccUrl,
          title: data.bncc.strainDesignations,
          info: "BNCC" + data.bncc.id,
          id: data.bncc.id,
          brand: data.bncc.speciesGenus,
          summary: data.bncc.bnccid,
          url: { name: "bnccdetail", query: { id: route.params.id, classId: route.params.id } },
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return {
      bncc,
      id,
      isFav,
      comp,
      classId
    };
  },
});
